import { ERROR, SUCCESS } from "../constants/types/alertType";
import axios from "../utils/axios";
import {
  getUserDetail,
  isEmpty,
  setUsetDetailToLocalStorage,
} from "../utils/helper";
import history from "../utils/history";
import { appLoading } from "./alertAction";

export const login = (data) => (dispatch) => {
  dispatch(appLoading(true));
  axios.post("auth", data).then(
    (resp) => {
      if (resp.data.status === "success") {
        setUsetDetailToLocalStorage(resp.data);
        if (resp.data.role.includes(6) || resp.data.role.includes(7)) {
          debugger;
          if (resp.data.twoFAActivated) {
            history.push("/2fa");
          } else {
            history.push("/2fa-setup");
          }
        } else {
          if (resp.data.twoFAActivated) {
            history.push("/2fa");
          } else {
            history.push("/app");
          }
        }
      } else {
        dispatch({
          type: ERROR,
          payload: isEmpty(resp.data.message)
            ? "Failed to login"
            : resp.data.message,
        });
      }
      dispatch(appLoading(false));
    },
    (err) => {
      dispatch({
        type: ERROR,
        payload: "Failed to login",
      });
      dispatch(appLoading(false));
    }
  );
};

export const forgotPassword = (data, callback) => (dispatch) => {
  axios.post("auth", data).then(
    (resp) => {
      if (resp.data.result === "success") {
        callback && callback();
        dispatch({
          type: SUCCESS,
          payload: resp.data.message,
        });
      } else {
        dispatch({
          type: ERROR,
          payload: isEmpty(resp.data.error)
            ? "Failed to Complet Action"
            : resp.data.error,
        });
      }
    },
    (err) => {
      dispatch({
        type: ERROR,
        payload: "Failed to Complete Action",
      });
    }
  );
};

export const register = (data, callback) => (dispatch) => {
  axios.post("register", data).then(
    (resp) => {
      if (resp.data.result === "success") {
        dispatch({
          type: SUCCESS,
          payload: "Please check your email to confirm your account.",
        });
        callback && callback();
      } else {
        dispatch({
          type: ERROR,
          payload: isEmpty(resp.data.error)
            ? "Failed to Complete Action"
            : resp.data.error,
        });
      }
    },
    (err) => {
      dispatch({
        type: ERROR,
        payload: "Failed to Complet Action",
      });
    }
  );
};

export const registerWithImage = (data, callback) => (dispatch) => {
  axios({
    method: "post",
    url: "register",
    data: data,
    headers: { "Content-Type": "multipart/form-data" },
  }).then(
    (resp) => {
      if (resp.data.result === "success") {
        callback && callback();
        dispatch({
          type: SUCCESS,
          payload: resp.data.message,
        });
      } else {
        dispatch({
          type: ERROR,
          payload: resp.data.error,
        });
      }
    },
    (err) => {
      console.log(err);
      dispatch({
        type: ERROR,
        payload: "Failed to complete action",
      });
    }
  );
};

export const logout = () => (dispatch) => {
  localStorage.removeItem("userDetail");
  localStorage.removeItem("practitionerForAdmin");
  localStorage.removeItem("adminDetail");
  window.location.href = "/login";
};

export const checkIfAuthorized = (callback) => (dispatch) => {
  axios.get("profile?action=checkAuthorize").then(
    (resp) => {
      if (resp.data.result === "success") {
        callback();
      }
    },
    (err) => {
      callback();
    }
  );
};
